import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import useFunnelTelemetry from "../../hooks/useFunnelTelemetry";
import { useAuth } from "../../providers/AuthProvider";
import { getShareMemberId } from "./shareMemberIdentity";
import { SHARE_CAMPAIGN_VERSION, SHARE_LANDING_CAMPAIGN_VERSION } from "./shareCampaign";

// Facebook previews the destination URL directly. Measure human arrivals on /join
// without replacing the public landing page or its social preview with a redirect.
export default function ShareJoinAttribution({ children }) {
  const { search } = useLocation();
  const { currentUser, customClaims } = useAuth() || {};
  const memberId = getShareMemberId(currentUser, customClaims);
  const { trackFunnelView } = useFunnelTelemetry({ flow: "share_campaign", surface: "share_link", memberId });
  const observedRef = useRef(false);

  useEffect(() => {
    if (observedRef.current) return;
    const params = new URLSearchParams(search);
    const campaign = params.get("utm_campaign");
    if (params.get("utm_source") !== "member_share" || params.get("utm_medium") !== "facebook" || ![SHARE_CAMPAIGN_VERSION, SHARE_LANDING_CAMPAIGN_VERSION].includes(campaign)) return;
    observedRef.current = true;
    trackFunnelView("share_link_opened", { ctaId: "facebook", flyerVersion: SHARE_CAMPAIGN_VERSION, medium: "facebook", entrySource: campaign === SHARE_LANDING_CAMPAIGN_VERSION ? "landing_page" : "shared_link" });
  }, [search, trackFunnelView]);

  return children;
}
